import { useState } from 'react';

import {
    getActivePrefixes,
    getActiveProject,
    getProjectsEnabled,
    setActiveProject,
} from 'services/projectContext';

/**
 * Loud indicator that a project dev environment is selected, with controls to
 * switch or return to shared dev. Renders nothing when no project is active
 * and the switcher is closed — production builds without the router simply
 * never have the cookie set.
 */
/**
 * Bottom-left rather than over the header, and click-through by default.
 *
 * `position: fixed` at the top centre sat on top of the header's controls and
 * swallowed clicks meant for the buttons underneath. Anchoring to the bottom
 * left keeps it out of every app's toolbar, and `pointerEvents: 'auto'` on the
 * chip itself means only the chip is clickable while the space around it is
 * not. StrataHeader takes no children, so rendering inside the header would
 * mean changing a published package.
 */
const anchor = {
    position: 'fixed',
    bottom: 12,
    left: 12,
    zIndex: 2000,
    pointerEvents: 'auto',
};

export const ProjectBadge = () => {
    const activeProject = getActiveProject();
    const [showSwitcher, setShowSwitcher] = useState(false);
    const [draft, setDraft] = useState('');

    // Selection is only offered where project environments exist (non-prod).
    // Selection is only offered where project environments exist: dev. One
    // source of truth with projectContext, which is inert everywhere else.
    const projectsAvailable = getProjectsEnabled();
    if (!activeProject && !projectsAvailable) {
        return null;
    }
    if (!activeProject && !showSwitcher) {
        return (
            <button
                type="button"
                onClick={() => setShowSwitcher(true)}
                style={{
                    ...anchor,
                    borderRadius: 999,
                    padding: '2px 10px',
                    fontSize: 12,
                    opacity: 0.6,
                }}
            >
                Select project…
            </button>
        );
    }

    return (
        <div
            style={{
                ...anchor,
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                background: '#B54708',
                color: '#fff',
                borderRadius: 999,
                padding: '4px 12px',
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
            }}
        >
            {activeProject ? (
                <>
                    <span
                        title={`claimed: ${getActivePrefixes().join(', ') || 'none — all calls go to shared dev'}`}
                    >
                        Viewing project: {activeProject}
                    </span>
                    <button type="button" onClick={() => setShowSwitcher(true)}>
                        Switch
                    </button>
                    <button type="button" onClick={() => setActiveProject(undefined)}>
                        Back to dev
                    </button>
                </>
            ) : null}
            {showSwitcher ? (
                <form
                    style={{ display: 'flex', gap: 4 }}
                    onSubmit={(event) => {
                        event.preventDefault();
                        setActiveProject(draft.trim().toLowerCase());
                    }}
                >
                    <input
                        placeholder="project name"
                        value={draft}
                        onChange={(event) => setDraft(event.target.value)}
                    />
                    <button type="submit">Go</button>
                    <button type="button" onClick={() => setShowSwitcher(false)}>
                        Cancel
                    </button>
                </form>
            ) : null}
        </div>
    );
};
